export const fonts = {
  heading: "Flink-Bold",
  body: "Flink-Regular",
};
